export function toCsv(rows, { columns } = {}) {
  const arr = Array.isArray(rows) ? rows : [];
  if (arr.length === 0) return '';
  const cols = Array.isArray(columns) && columns.length
    ? columns
    : Array.from(arr.reduce((s, r) => {
      Object.keys(r || {}).forEach(k => s.add(k));
      return s;
    }, new Set()));

  const esc = (v) => {
    if (v === null || v === undefined) return '';
    let s = v;
    if (typeof s === 'object') s = JSON.stringify(s);
    s = String(s);
    if (/[",\n]/.test(s)) s = `"${s.replace(/"/g, '""')}"`;
    return s;
  };

  const lines = [];
  lines.push(cols.map(esc).join(','));
  for (const r of arr) {
    lines.push(cols.map(c => esc((r || {})[c])).join(','));
  }
  return lines.join('\n');
}

export function downloadCsv(filename, rows, opts = {}) {
  const csv = toCsv(rows, opts);
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename.endsWith('.csv') ? filename : `${filename}.csv`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  window.URL.revokeObjectURL(url);
}

